import { configureStore } from '@reduxjs/toolkit';
import notificationReducer from './slices/notificationSlice';
import popupReducer from './slices/popupSlice';
import authReducer from './slices/authSlice';
import anagraficaReducer from './slices/anagraficaSlice';
import agendaReducer from './slices/agendaSlice';
import documentoReducer from './slices/documentoSlice';
import accountReducer from './slices/accountSlice';
import notaReducer from './slices/notaSlice';

export const store = configureStore({
  reducer: {
    notification: notificationReducer,
    popup: popupReducer,
    auth: authReducer,
    anagrafica: anagraficaReducer,
    documento: documentoReducer,
    agenda: agendaReducer,
    account: accountReducer,
    nota: notaReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
